var render, staticRenderFns
import script from "./refreshPage.vue?vue&type=script&lang=js"
export * from "./refreshPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd4c67",
  null
  
)

export default component.exports